import { useState } from "react";
import { useHistory } from "react-router-dom";
import { ReceivedDocument } from "../models/received-document";
import ReceivedDocumentCdcEntry from "../components/received-document/ReceivedDocumentCdcEntry";
import ReceivedDocumentCdcPreview from "../components/received-document/ReceivedDocumentCdcPreview";
import ReceivedDocumentForm from "../components/received-document/ReceivedDocumentForm";

type PageState = "cdc_entry" | "cdc_preview" | "manual_form";

const ReceivedDocumentPage = () => {
  const history = useHistory();
  const urlParams = new URLSearchParams(history.location.search);
  const editingId = urlParams.get("id");
  const isNew = editingId === null || isNaN(parseInt(editingId));

  const [pageState, setPageState] = useState<PageState>(
    isNew ? "cdc_entry" : "manual_form",
  );
  const [cdcData, setCdcData] = useState<ReceivedDocument | null>(null);
  const [cdc, setCdc] = useState<string>("");

  if (pageState === "cdc_entry") {
    return (
      <ReceivedDocumentCdcEntry
        onSuccess={(data, cdcValue) => {
          setCdcData(data);
          setCdc(cdcValue);
          setPageState("cdc_preview");
        }}
        onManual={() => setPageState("manual_form")}
      />
    );
  }

  if (pageState === "cdc_preview" && cdcData !== null) {
    return (
      <ReceivedDocumentCdcPreview
        data={cdcData}
        cdc={cdc}
        onCancel={() => setPageState("cdc_entry")}
      />
    );
  }

  return <ReceivedDocumentForm />;
};

export default ReceivedDocumentPage;
